import Vue from 'vue'

export default {
  /**
   * 更改左边框缩进状况
   */
  changeCollapse(state) {
    state.isCollapse = !state.isCollapse;
  },
  changeLeftnavnum(state,index) {
    state.adminleftnavnum = index;
  },
  saveauth(state, data) {
    state.token = data;
    window.localStorage.setItem("auth", data);
  },
  saveTokenExpire(state, data) {
      state.tokenExpire = data;
      window.localStorage.setItem("TokenExpire", data);
  },
}
